/**
 * Wunschmoment Kalender — Personalisierungs-Popup (Schritt C)
 * - Layer-Stack-Vorschau (base/magnetboard/wandhalter/druck) + SVG-Text-Layer (Titel/Namen/rechte Titel)
 * - 3 Varianten (Größe/Wandhalter/Magnetboard) im Popup, SYNCHRON mit der PDP-Buybox
 * - Personen (1–6) + Texteingaben live
 * - Öffnen via window.wmOpenCalendarPersonalizer() (Buybox-Button), ATC mit _calendar_config
 *
 * Platzhalter-Schrift; echte Fonts + Preview-Upload folgen später.
 */
(function () {
  'use strict';

  var cfg = window.wmCalendar;
  var popup = document.getElementById('wm-cal-popup');
  if (!cfg || !popup) return;

  // Backend-Upload (wie Puzzle): personalisierte Warenkorb-Vorschau → Supabase.
  var API_BASE = 'https://wunschmoment-backend.vercel.app';
  var SIGNED_URL_ENDPOINT = API_BASE + '/api/upload/signed-url';

  var SVGNS = 'http://www.w3.org/2000/svg';

  // Layout-Anker (Titel/Namen/rechte Felder) pro Layout, EXAKT aus den .ai-Druckdateien extrahiert
  // (Familienkalender/_extract_layout.py → cal-layout.js). Schlüssel: "{persons}p_{mag|nomag}_{WxH}".
  // Jedes Element: { cx, cy (Baseline), relSize (× Höhe), maxW (× Breite, Shrink-to-Fit) } — alle relativ 0..1.
  var LAYOUT = window.wmCalLayout || {};
  // Aktuelle Vorschau-Dimensionen (mm des gewählten Artboards); für Text-Layer-Koordinaten.
  var curW = 800, curH = 600;

  var FONT_FAMILY = "'Libre Baskerville', serif";

  // ── Elemente ──
  var elPreview = popup.querySelector('.wm-cal-popup__preview');
  var elBase = popup.querySelector('.wm-cal-popup__base');
  var elMag = popup.querySelector('.wm-cal-popup__magnetboard');
  var elWand = popup.querySelector('.wm-cal-popup__wandhalter');
  var elDruck = popup.querySelector('.wm-cal-popup__druck');
  var elText = popup.querySelector('.wm-cal-popup__text');

  var picker = popup.querySelector('.wm-cal-popup-variant-picker');
  var titleInput = popup.querySelector('[data-cal="title"]');
  var nameInputs = Array.prototype.slice.call(popup.querySelectorAll('[data-cal="name"]'));
  var rightInputs = Array.prototype.slice.call(popup.querySelectorAll('[data-cal="right"]'));
  var atcBtn = document.getElementById('wm-cal-popup-atc');
  var closeBtn = document.getElementById('wm-cal-popup-close');

  // persons = Anzahl fürs Rendering (Default 4 nur illustrativ); personsChosen = hat der Kunde gewählt?
  // fontScale/letterSpacing = die AKTIVEN Werte (der aktuellen Schrift); fontSettings speichert
  // pro Schriftart eigene Werte { '<font>': { scale, spacing } }. Beim Schriftwechsel werden die
  // Werte der Zielschrift geladen (oder Default 1/0), die alten bleiben pro Schrift erhalten.
  var state = { persons: parseInt(cfg.defaultPersons, 10) || 4, personsChosen: false, font: FONT_FAMILY, fontScale: 1, letterSpacing: 0, fontSettings: {} };

  // Varianten-Daten aus der PDP lesen (eine Quelle)
  var variants = [];
  (function () {
    var dataEl = popup.querySelector('[data-wm-cal-variants]');
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) {} }
  })();

  // ── Token-Helfer ──
  function norm(v) { return (v || '').toString().toLowerCase(); }
  function colorToken(v) { v = norm(v); if (v.indexOf('weiß') > -1 || v.indexOf('weiss') > -1) return 'weiss'; if (v.indexOf('gold') > -1) return 'gold'; if (v.indexOf('silber') > -1) return 'silber'; return 'schwarz'; }
  function magToken(v) { v = norm(v); if (v.indexOf('ohne') > -1 || v === '') return 'ohne'; if (v.indexOf('weiß') > -1 || v.indexOf('weiss') > -1) return 'weiss'; if (v.indexOf('schwarz') > -1) return 'schwarz'; return 'ohne'; }
  function sizeInfo(v) { var m = (v || '').match(/(\d+)\s*[x×]\s*(\d+)/i); return m ? { w: +m[1], h: +m[2], token: m[1] + 'x' + m[2] } : { w: 80, h: 60, token: '80x60' }; }

  // ── Optionen aus dem Popup-Picker lesen ──
  function optionName(group) {
    var s = group.querySelector('.wm-size-header__label strong');
    return s ? s.textContent.replace(':', '').trim() : '';
  }
  function readOptions() {
    var byName = {}, byPos = [];
    popup.querySelectorAll('.wm-cal-popup-variant-picker .wm-cal-option').forEach(function (group) {
      var active = group.querySelector('.wm-size-btn--active');
      var val = active ? active.dataset.optionValue : null;
      byName[optionName(group)] = val;
      byPos[parseInt(group.dataset.optionPosition, 10) - 1] = val;
    });
    return { byName: byName, byPos: byPos };
  }
  function resolveVariant(byPos) {
    for (var i = 0; i < variants.length; i++) {
      var o = variants[i].options, ok = true;
      for (var p = 0; p < byPos.length; p++) { if (byPos[p] != null && o[p] !== byPos[p]) { ok = false; break; } }
      if (ok) return variants[i];
    }
    return null;
  }
  function formatMoney(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  function formatMoneyShort(cents) { return (cents % 100 === 0) ? (cents / 100) + ' €' : formatMoney(cents); }

  // ── Preise (Magnetboard-Aufpreis, Größe-Basispreis ohne Magnetboard) ──
  var optPositions = {}; // Options-Name → 1-basierte Position im variant.options-Array
  popup.querySelectorAll('.wm-cal-popup-variant-picker .wm-cal-option').forEach(function (g) {
    optPositions[optionName(g)] = parseInt(g.dataset.optionPosition, 10);
  });
  function variantOpt(v, name) { var p = optPositions[name]; return p ? v.options[p - 1] : null; }

  function priceForSizeNoMag(sizeValue) {
    for (var i = 0; i < variants.length; i++) {
      if (variantOpt(variants[i], cfg.optionNames.size) === sizeValue &&
          magToken(variantOpt(variants[i], cfg.optionNames.magnetboard)) === 'ohne') return variants[i].price;
    }
    return null;
  }
  function compareForSizeNoMag(sizeValue) { // Streichpreis derselben Variante (Größe ohne Magnetboard)
    for (var i = 0; i < variants.length; i++) {
      if (variantOpt(variants[i], cfg.optionNames.size) === sizeValue &&
          magToken(variantOpt(variants[i], cfg.optionNames.magnetboard)) === 'ohne') return variants[i].compare || 0;
    }
    return 0;
  }
  function magSurcharge() { // Aufpreis Magnetboard (flach): mit − ohne bei gleicher Größe+Wandhalter
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (magToken(variantOpt(v, cfg.optionNames.magnetboard)) === 'ohne') continue;
      for (var j = 0; j < variants.length; j++) {
        var w = variants[j];
        if (magToken(variantOpt(w, cfg.optionNames.magnetboard)) === 'ohne' &&
            variantOpt(w, cfg.optionNames.size) === variantOpt(v, cfg.optionNames.size) &&
            variantOpt(w, cfg.optionNames.wandhalter) === variantOpt(v, cfg.optionNames.wandhalter)) return v.price - w.price;
      }
    }
    return 2000;
  }
  var MAG_SURCHARGE = magSurcharge();

  function updateSizePrice() { // Preis der AUSGEWÄHLTEN Größe (ohne Magnetboard) im Header rechts
    var el = popup.querySelector('[data-size-price]');
    if (!el) return;
    var group = findOptionGroup(cfg.optionNames.size);
    var active = group && group.querySelector('.wm-size-btn--active');
    var p = active ? priceForSizeNoMag(active.dataset.optionValue) : null;
    el.textContent = (p != null) ? formatMoneyShort(p) : '';
  }
  function updateMagPrice() {
    var el = popup.querySelector('[data-mag-price]');
    if (!el) return;
    var group = findOptionGroup(cfg.optionNames.magnetboard);
    var active = group && group.querySelector('.wm-size-btn--active');
    if (!active) { el.textContent = ''; return; }
    el.textContent = magToken(active.dataset.optionValue) === 'ohne' ? '0 €' : formatMoneyShort(MAG_SURCHARGE);
  }

  // ── Geführter Button: nächster offener Schritt ──
  var GUIDE = {
    persons: 'Wähle die Personenzahl',
    title: 'Gib deine Überschrift ein',
    names: 'Gib eure Namen ein',
    right: 'Benenne die rechten Felder',
    wandhalter: 'Wähle die Wandhalter Farbe',
    magnetboard: 'Mit oder ohne Magnetboard?',
    size: 'Wähle die Größe',
    marker: 'Wähle deinen gratis Kreidemarker'
  };
  function filled(inp) { return inp && inp.value.trim() !== ''; }

  // Optionale Textschritte (Titel/Namen/rechte Felder) dürfen leer bleiben: sie gelten als erledigt,
  // sobald sie ausgefüllt ODER "besucht" sind. Besucht = Feld wurde fokussiert und wieder verlassen (blur).
  // KEIN Pass-through: ein Sprung zu einer späteren Variante akzeptiert die darüber liegenden Felder NICHT.
  var visited = {};
  function optVisited(step) { return visited[step] === true; }

  function nextStep() {
    if (!state.personsChosen) return 'persons';                                    // Pflicht
    if (!filled(titleInput) && !optVisited('title')) return 'title';               // optional
    var namesOk = true;
    for (var i = 0; i < state.persons; i++) { if (!filled(nameInputs[i])) { namesOk = false; break; } }
    if (!namesOk && !optVisited('names')) return 'names';                          // optional
    if ((!filled(rightInputs[0]) || !filled(rightInputs[1])) && !optVisited('right')) return 'right'; // optional
    var o = readOptions().byName;
    if (!o[cfg.optionNames.wandhalter]) return 'wandhalter';                        // Pflicht
    if (giftBtns && giftBtns.length && !state.markerVariant) return 'marker';       // Pflicht (falls Marker vorhanden)
    if (!o[cfg.optionNames.magnetboard]) return 'magnetboard';                      // Pflicht
    if (!o[cfg.optionNames.size]) return 'size';                                    // Pflicht
    return null;
  }
  function updateButton(variant) {
    if (!atcBtn) return;
    var step = nextStep();
    if (step) {
      atcBtn.dataset.mode = 'guide';
      atcBtn.dataset.step = step;
      atcBtn.textContent = GUIDE[step];
    } else {
      atcBtn.dataset.mode = 'atc';
      atcBtn.removeAttribute('data-step');
      atcBtn.textContent = 'In den Warenkorb' + (variant ? ' · ' + formatMoney(variant.price) : '');
    }
  }
  function updateNameVisibility() {
    // Standardmäßig so viele Namensfelder wie state.persons (Default 4 aus dem Template) sichtbar —
    // auch bevor der Kunde die Personenzahl bestätigt hat.
    nameInputs.forEach(function (inp, idx) {
      inp.classList.toggle('is-hidden', idx >= state.persons);
    });
  }

  // ── Kreuz-Sperre: Magnetboard (Weiß/Schwarz) gibt es NICHT für Größe 60×40 ──
  function setDisabled(btn, dis) {
    btn.disabled = dis;
    btn.classList.toggle('is-disabled', dis);
    btn.setAttribute('aria-disabled', dis ? 'true' : 'false');
  }
  function applyConstraints(o) {
    var byName = o.byName;
    var sizeVal = byName[cfg.optionNames.size];
    var magVal = byName[cfg.optionNames.magnetboard];
    var is60 = sizeVal && sizeInfo(sizeVal).token === '60x40';
    var magT = magVal ? magToken(magVal) : null;
    var magActive = magT === 'weiss' || magT === 'schwarz';

    // Größe 60×40 sperren, wenn Magnetboard (Weiß/Schwarz) gewählt
    var sizeGroup = findOptionGroup(cfg.optionNames.size);
    if (sizeGroup) sizeGroup.querySelectorAll('.wm-size-btn').forEach(function (b) {
      setDisabled(b, sizeInfo(b.dataset.optionValue).token === '60x40' && magActive);
    });
    // Magnetboard Weiß/Schwarz sperren, wenn Größe 60×40 gewählt
    var magGroup = findOptionGroup(cfg.optionNames.magnetboard);
    if (magGroup) magGroup.querySelectorAll('.wm-size-btn').forEach(function (b) {
      var mt = magToken(b.dataset.optionValue);
      setDisabled(b, (mt === 'weiss' || mt === 'schwarz') && is60);
    });
  }

  // ── Layout-Schlüssel: Personenzahl × Magnetboard × Größe → "4p_nomag_80x60" ──
  function layoutKey(opt) {
    var mag = magToken(opt.byName[cfg.optionNames.magnetboard]) !== 'ohne' ? 'mag' : 'nomag';
    var size = sizeInfo(opt.byName[cfg.optionNames.size]).token; // z.B. "80x60"
    return state.persons + 'p_' + mag + '_' + size;
  }
  function currentLayout(opt) {
    return LAYOUT[layoutKey(opt)] || LAYOUT[state.persons + 'p_nomag_80x60'] || LAYOUT['4p_nomag_80x60'];
  }

  // ── Layer-Vorschau ──
  function renderLayers(opt) {
    var wand = colorToken(opt.byName[cfg.optionNames.wandhalter]);
    var mag = magToken(opt.byName[cfg.optionNames.magnetboard]);
    var magPresent = mag !== 'ohne';
    var suffix = magPresent ? 'fuer' : 'ohne';
    var key = layoutKey(opt);
    var L = LAYOUT[key] || currentLayout(opt);

    // Seitenverhältnis + SVG-Koordinatensystem = mm des Artboards (Anker sind relativ dazu).
    var mm = (L && L.mm) || [80, 60];
    curW = mm[0]; curH = mm[1];
    elPreview.style.aspectRatio = curW + ' / ' + curH;
    elText.setAttribute('viewBox', '0 0 ' + curW + ' ' + curH);

    // base = Acrylglas-Mockup (unten), druck = transparentes Design-Overlay pro Layout (darüber)
    if (cfg.base) elBase.src = cfg.base;
    if (cfg.bg[key]) elDruck.src = cfg.bg[key];

    if (magPresent && cfg.magnetboard[mag]) { elMag.src = cfg.magnetboard[mag]; elMag.hidden = false; }
    else { elMag.hidden = true; elMag.removeAttribute('src'); }

    if (cfg.wandhalter[wand]) elWand.src = cfg.wandhalter[wand][suffix];
  }

  // ── Text-Layer ──
  // Zeichnet Text zentriert auf einer festen Baseline (a.cy). Ist er breiter als a.maxW, wird die
  // Schriftgröße heruntergerechnet, bis er passt. Baseline bleibt fix (wie im Design).
  function addBoxedText(a, value, ph) {
    if (!a) return;
    var maxW = (a.maxW || 0.9) * curW;
    var fs = a.relSize * curH * (state.fontScale || 1); // Experten: globale Schriftgrößen-Skalierung
    var filled = (value || '').trim();
    var t = document.createElementNS(SVGNS, 'text');
    t.setAttribute('x', a.cx * curW); t.setAttribute('y', a.cy * curH); // cy = Baseline
    t.setAttribute('font-size', fs); t.setAttribute('text-anchor', 'middle');
    t.setAttribute('font-family', state.font); t.setAttribute('font-weight', '300');
    if (state.letterSpacing) t.setAttribute('letter-spacing', state.letterSpacing); // Experten: Buchstabenabstand
    t.setAttribute('fill', filled ? '#111111' : '#c6c6c6');
    t.textContent = filled || ph || '';
    elText.appendChild(t);
    // Auf maxW schrumpfen (Baseline bleibt fix, Text wird nur kleiner)
    try {
      var len = t.getComputedTextLength();
      if (len > maxW) t.setAttribute('font-size', fs * maxW / len);
    } catch (e) {}
  }
  function ph(el) { return el ? (el.getAttribute('placeholder') || '') : ''; }
  function renderText(opt) {
    var L = currentLayout(opt);
    while (elText.firstChild) elText.removeChild(elText.firstChild);
    if (!L) return;
    addBoxedText(L.title, titleInput && titleInput.value, ph(titleInput));
    for (var i = 0; i < state.persons && i < L.names.length; i++) {
      addBoxedText(L.names[i], nameInputs[i] && nameInputs[i].value, ph(nameInputs[i]));
    }
    if (L.right[0]) addBoxedText(L.right[0], rightInputs[0] && rightInputs[0].value, ph(rightInputs[0]));
    if (L.right[1]) addBoxedText(L.right[1], rightInputs[1] && rightInputs[1].value, ph(rightInputs[1]));
  }

  function updateAll() {
    var opt = readOptions();
    renderLayers(opt);
    renderText(opt);
    applyConstraints(opt);
    updateSizePrice();
    updateMagPrice();
    syncPdpSize();
    var variant = resolveVariant(opt.byPos);
    updateButton(variant);
    saveState();
    return { opt: opt, variant: variant };
  }

  // ── Popup-Variant-Buttons ──
  if (picker) {
    picker.querySelectorAll('.wm-size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = parseInt(btn.dataset.optionPosition, 10);
        picker.querySelectorAll('.wm-size-btn[data-option-position="' + pos + '"]').forEach(function (b) { b.classList.remove('wm-size-btn--active'); });
        btn.classList.add('wm-size-btn--active');
        var h = picker.querySelector('[data-option-header="' + pos + '"]');
        if (h) h.textContent = btn.dataset.optionValue;
        updateAll();
      });
    });
  }

  // ── PDP-Größen-Picker (zeigt die Größen auf der Produktseite wie beim Puzzle) ──
  // Bindeglied PDP ↔ Popup: Ein Klick auf der PDP wählt dieselbe Größe im Popup vor (updateAll →
  // syncPdpSize spiegelt Aktiv-Zustand + Preis zurück). updateAll() ruft syncPdpSize() am Ende auf,
  // d.h. Größenwechsel IM Popup aktualisiert auch die PDP-Anzeige. Preis = Basispreis der Größe
  // ohne Magnetboard (konkret, ohne „ab"); der Magnetboard-Aufpreis kommt erst im Popup dazu.
  var pdpSizeBtns = Array.prototype.slice.call(document.querySelectorAll('.wm-cal-pdp-size-btn'));
  var pdpSizeValueEl = document.querySelector('[data-cal-pdp-size-value]');
  var pdpPriceEl = document.querySelector('#wm-custom-price [data-cal-price]');
  var pdpCompareEl = document.querySelector('#wm-custom-price [data-cal-compare]');

  function activatePopupSize(sizeValue) { // Größe im Popup-Picker aktiv setzen (ohne updateAll)
    var g = findOptionGroup(cfg.optionNames.size);
    if (!g) return null;
    var target = null;
    g.querySelectorAll('.wm-size-btn').forEach(function (b) {
      var a = b.dataset.optionValue === sizeValue;
      b.classList.toggle('wm-size-btn--active', a);
      if (a) target = b;
    });
    if (target && picker) { var h = picker.querySelector('[data-option-header="' + target.dataset.optionPosition + '"]'); if (h) h.textContent = sizeValue; }
    return target;
  }
  function selectPopupSize(sizeValue) { activatePopupSize(sizeValue); updateAll(); }

  function syncPdpSize() { // aktive Größe aus dem Popup auf die PDP spiegeln (Aktiv-Button + Preis)
    if (!pdpSizeBtns.length) return;
    var g = findOptionGroup(cfg.optionNames.size);
    var active = g && g.querySelector('.wm-size-btn--active');
    var sizeValue = active ? active.dataset.optionValue : null;
    pdpSizeBtns.forEach(function (b) { b.classList.toggle('wm-size-btn--active', sizeValue != null && b.dataset.calSizeValue === sizeValue); });
    if (pdpSizeValueEl) pdpSizeValueEl.textContent = sizeValue || '';
    if (!sizeValue) return;
    var p = priceForSizeNoMag(sizeValue);
    if (p != null && pdpPriceEl) pdpPriceEl.textContent = formatMoney(p);
    if (pdpCompareEl) {
      var c = compareForSizeNoMag(sizeValue);
      var showCompare = c && p != null && c > p;
      pdpCompareEl.textContent = showCompare ? formatMoney(c) : '';
      pdpCompareEl.hidden = !showCompare;
      if (pdpPriceEl) pdpPriceEl.classList.toggle('wm-price__current--sale', !!showCompare);
    }
  }
  function pdpDefaultSize() {
    var active = pdpSizeBtns.filter(function (b) { return b.classList.contains('wm-size-btn--active'); })[0] || pdpSizeBtns[0];
    return active ? active.dataset.calSizeValue : null;
  }
  pdpSizeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () { selectPopupSize(btn.dataset.calSizeValue); });
  });

  // ── Personen ──
  var personBtns = Array.prototype.slice.call(popup.querySelectorAll('.wm-cal__person-btn'));
  personBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.persons = parseInt(btn.getAttribute('data-persons'), 10) || 1;
      state.personsChosen = true;
      personBtns.forEach(function (b) { var a = b === btn; b.classList.toggle('is-active', a); b.setAttribute('aria-pressed', a ? 'true' : 'false'); });
      updateNameVisibility();
      updateAll();
    });
  });

  // ── Gratis-Kreidemarker (Geschenk) — eigener (letzter) Pflicht-Step, KEINE Vorauswahl ──
  var giftBtns = Array.prototype.slice.call(popup.querySelectorAll('.wm-cal-gift__btn'));
  var giftValue = document.getElementById('wm-cal-gift-value');
  var giftStrike = document.getElementById('wm-cal-gift-strike');
  var giftPack = document.getElementById('wm-cal-giftpack');
  function setGiftValue(l) { if (giftValue) giftValue.textContent = l || ''; }
  function setGiftStrike(cents) { if (giftStrike) giftStrike.textContent = cents ? formatMoney(cents) : ''; }
  // Freisteller unten rechts über dem Kalender; blendet nur ein, wenn das Bild wirklich lädt (fehlt es, bleibt es aus).
  function setGiftPack(url) {
    if (!giftPack) return;
    if (!url) { giftPack.hidden = true; giftPack.classList.remove('is-visible'); giftPack.removeAttribute('src'); return; }
    giftPack.onload = function () { giftPack.hidden = false; giftPack.classList.add('is-visible'); };
    giftPack.onerror = function () { giftPack.hidden = true; giftPack.classList.remove('is-visible'); };
    giftPack.src = url;
  }
  state.markerVariant = null;
  setGiftValue('');
  setGiftStrike(0);
  setGiftPack('');
  giftBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      giftBtns.forEach(function (b) { b.classList.remove('wm-size-btn--active'); });
      btn.classList.add('wm-size-btn--active');
      state.markerVariant = btn.dataset.markerId;
      setGiftValue(btn.dataset.markerLabel);
      setGiftStrike(parseInt(btn.dataset.markerPrice, 10) || 0);
      setGiftPack(btn.dataset.markerImg);
      updateAll(); // Button-Step aktualisieren
    });
  });

  // ── Eingaben ──
  [titleInput].concat(nameInputs, rightInputs).forEach(function (inp) {
    if (!inp) return;
    inp.addEventListener('input', updateAll);
    // Verlassen des Felds (blur) markiert diesen Textschritt als besucht → darf leer bleiben.
    inp.addEventListener('blur', function () {
      visited[inp.dataset.cal === 'title' ? 'title' : inp.dataset.cal === 'name' ? 'names' : 'right'] = true;
      updateAll();
    });
  });

  // ── Öffnen / Schließen ──
  // Loox-Rating aus der PDP ins Popup klonen (nur Anzeige, ohne Link). Loox lädt async →
  // beim Öffnen (ggf. mit kurzem Retry) klonen. Klon landet in einem Nicht-.loox-rating-Container,
  // damit Loox ihn nicht erneut scannt/zählt.
  function syncRating(tries) {
    var host = document.getElementById('wm-cal-rating');
    if (!host || host.dataset.filled) return;
    var src = document.querySelector('.loox-rating');
    if (src && src.innerHTML.trim()) {
      // GANZES Element klonen (inkl. class="loox-rating") → Loox-CSS greift → exakt wie PDP.
      var clone = src.cloneNode(true);
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      if (clone.tagName === 'A') clone.removeAttribute('href');
      clone.querySelectorAll('a').forEach(function (a) { a.removeAttribute('href'); a.removeAttribute('onclick'); });
      host.innerHTML = '';
      host.appendChild(clone);
      host.dataset.filled = '1';
    } else if ((tries || 0) < 20) {
      setTimeout(function () { syncRating((tries || 0) + 1); }, 250);
    }
  }

  // Mobile: Header (Logo + Zurück) wird 1:1 MIT dem Scroll verschoben — beim Runterscrollen
  // schiebt er sich im gleichen Tempo raus, beim Hochscrollen wieder rein. Der Kalender rückt
  // synchron nach (Preview-top = 60 + offset). Popup ist der Scroll-Container.
  var elHeader = popup.querySelector('.wm-popup__header');
  var elPreviewSticky = popup.querySelector('.wm-popup__preview');
  var HEADER_H = 60;
  var headerOffset = 0;   // 0 = voll sichtbar, -HEADER_H = ganz raus
  var lastScrollY = 0, headerTicking = false;

  function applyHeaderOffset() {
    if (elHeader) elHeader.style.transform = 'translateY(' + headerOffset + 'px)';
    if (elPreviewSticky) elPreviewSticky.style.setProperty('--wm-hdr-off', headerOffset + 'px');
  }
  function resetHeader() {
    headerOffset = 0;
    lastScrollY = popup.scrollTop;
    if (elHeader) elHeader.style.transform = '';
    if (elPreviewSticky) elPreviewSticky.style.removeProperty('--wm-hdr-off');
  }
  popup.addEventListener('scroll', function () {
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    if (headerTicking) return;
    headerTicking = true;
    requestAnimationFrame(function () {
      var y = popup.scrollTop;
      headerOffset = Math.max(-HEADER_H, Math.min(0, headerOffset - (y - lastScrollY)));
      if (y <= 0) headerOffset = 0; // ganz oben: Header immer voll sichtbar (kein Drift/Overscroll-Artefakt)
      applyHeaderOffset();
      lastScrollY = y;
      headerTicking = false;
    });
  }, { passive: true });

  function openPopup() {
    popup.style.display = 'flex';
    document.body.classList.add('wm-popup-open');
    resetHeader();
    syncRating(0);
    updateAll();
  }
  function closePopup() {
    popup.style.display = 'none';
    document.body.classList.remove('wm-popup-open');
  }
  window.wmOpenCalendarPersonalizer = openPopup;

  // PDP-Button "Jetzt Kalender gestalten" öffnet das Popup (Form-Submit unterdrücken)
  var gestaltenBtn = document.getElementById('wm-cal-gestalten-btn');
  if (gestaltenBtn) {
    var gForm = gestaltenBtn.closest('form');
    if (gForm) gForm.addEventListener('submit', function (e) { e.preventDefault(); });
    gestaltenBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openPopup(); });
  }

  [closeBtn, document.getElementById('wm-cal-popup-close-desktop')].forEach(function (b) {
    if (b) b.addEventListener('click', closePopup);
  });
  // ── Überschriften-Vorschläge ──
  var suggestLink = document.getElementById('wm-cal-title-suggest');
  var suggest = document.getElementById('wm-cal-suggest');
  if (suggestLink && suggest) {
    suggestLink.addEventListener('click', function () { suggest.hidden = false; });
    suggest.querySelectorAll('[data-suggest-close]').forEach(function (el) {
      el.addEventListener('click', function () { suggest.hidden = true; });
    });
    suggest.querySelectorAll('.wm-cal-suggest__item').forEach(function (item) {
      item.addEventListener('click', function () {
        if (titleInput) {
          titleInput.value = item.getAttribute('data-suggest-value') || item.textContent.trim();
          titleInput.dispatchEvent(new Event('input', { bubbles: true })); // Vorschau aktualisieren
        }
        suggest.hidden = true;
      });
    });
  }

  // ── Schriftart: eigenes Dropdown (Optionen in ihrer Schrift) ──
  // Lädt die (pro Schrift gespeicherten) Experten-Werte in State + Slider-UI. Wird im Experten-Block
  // zugewiesen; hier nur vordeklariert, damit der Dropdown-Handler sie nutzen kann.
  var loadFontSettings = null;

  var fontDD = document.getElementById('wm-cal-font');
  if (fontDD) {
    var ddToggle = fontDD.querySelector('.wm-cal-fontdd__toggle');
    var ddList = fontDD.querySelector('.wm-cal-fontdd__list');
    var ddCurrent = fontDD.querySelector('.wm-cal-fontdd__current');
    var ddItems = Array.prototype.slice.call(fontDD.querySelectorAll('.wm-cal-fontdd__item'));
    var ddInit = fontDD.querySelector('.wm-cal-fontdd__item[aria-selected="true"]') || ddItems[0];
    if (ddInit) { state.font = ddInit.getAttribute('data-font') || state.font; }
    function closeFontDD() { ddList.hidden = true; ddToggle.setAttribute('aria-expanded', 'false'); popup.style.overflow = ''; }
    function openFontDD() { ddList.hidden = false; ddToggle.setAttribute('aria-expanded', 'true'); popup.style.overflow = 'hidden'; } // Popup nicht scrollbar, solange offen
    ddToggle.addEventListener('click', function (e) { e.stopPropagation(); if (ddList.hidden) openFontDD(); else closeFontDD(); });
    ddItems.forEach(function (item) {
      item.addEventListener('click', function () {
        ddItems.forEach(function (b) { b.setAttribute('aria-selected', 'false'); });
        item.setAttribute('aria-selected', 'true');
        state.font = item.getAttribute('data-font');
        ddCurrent.textContent = item.textContent;
        ddCurrent.style.fontFamily = state.font;
        if (loadFontSettings) loadFontSettings(state.font); // Experten-Werte dieser Schrift (oder Default) aktivieren
        closeFontDD();
        updateAll();
        // Webschrift sicher laden, dann neu rendern (sonst misst Shrink-to-Fit die Fallback-Schrift)
        if (document.fonts && document.fonts.load) {
          try { document.fonts.load('20px ' + state.font).then(function () { updateAll(); }, function () {}); } catch (e) {}
        }
      });
    });
    document.addEventListener('click', function (e) { if (!fontDD.contains(e.target)) closeFontDD(); });
  }

  // ── Experten-Einstellungen: Schriftgröße + Buchstabenabstand (live) ──
  var expertLink = document.getElementById('wm-cal-expert-link');
  var expert = document.getElementById('wm-cal-expert');
  if (expertLink && expert) {
    var fsRange = document.getElementById('wm-cal-fontscale');
    var fsVal = document.getElementById('wm-cal-fontscale-val');
    var lsRange = document.getElementById('wm-cal-letterspacing');
    var lsVal = document.getElementById('wm-cal-letterspacing-val');
    var expReset = document.getElementById('wm-cal-expert-reset');
    function applyExpert() {
      state.fontScale = (parseInt(fsRange.value, 10) || 100) / 100;
      state.letterSpacing = parseInt(lsRange.value, 10) || 0;
      if (fsVal) fsVal.textContent = fsRange.value + ' %';
      if (lsVal) lsVal.textContent = lsRange.value;
      // Werte NUR für die aktuelle Schrift merken (Default 1/0 wird nicht gespeichert → spart Platz)
      if (state.fontScale === 1 && state.letterSpacing === 0) { delete state.fontSettings[state.font]; }
      else { state.fontSettings[state.font] = { scale: state.fontScale, spacing: state.letterSpacing }; }
      updateAll();
    }
    // Aktiviert die gespeicherten Werte einer Schrift (oder Default) in State + Slider-UI. Kein updateAll hier
    // (der Aufrufer rendert danach selbst).
    loadFontSettings = function (font) {
      var s = state.fontSettings[font] || { scale: 1, spacing: 0 };
      state.fontScale = s.scale;
      state.letterSpacing = s.spacing;
      fsRange.value = Math.round(state.fontScale * 100);
      lsRange.value = state.letterSpacing;
      if (fsVal) fsVal.textContent = fsRange.value + ' %';
      if (lsVal) lsVal.textContent = String(state.letterSpacing);
    };
    expertLink.addEventListener('click', function () { expert.hidden = false; });
    expert.querySelectorAll('[data-expert-close]').forEach(function (el) { el.addEventListener('click', function () { expert.hidden = true; }); });
    fsRange.addEventListener('input', applyExpert);
    lsRange.addEventListener('input', applyExpert);
    if (expReset) expReset.addEventListener('click', function () { fsRange.value = 100; lsRange.value = 0; applyExpert(); });
  }

  // ── Vorschläge für die rechten Felder (2 Bereiche; füllt je nach data-suggest-field, bleibt offen) ──
  var rightSuggestLink = document.getElementById('wm-cal-right-suggest');
  var rightSuggest = document.getElementById('wm-cal-suggest-right');
  if (rightSuggestLink && rightSuggest) {
    rightSuggestLink.addEventListener('click', function () { rightSuggest.hidden = false; });
    rightSuggest.querySelectorAll('[data-suggest-close]').forEach(function (el) {
      el.addEventListener('click', function () { rightSuggest.hidden = true; });
    });
    rightSuggest.querySelectorAll('.wm-cal-suggest__item').forEach(function (item) {
      item.addEventListener('click', function () {
        var idx = parseInt(item.getAttribute('data-suggest-field'), 10) || 0;
        var inp = rightInputs[idx];
        if (inp) {
          inp.value = item.getAttribute('data-suggest-value') || item.textContent.trim();
          inp.dispatchEvent(new Event('input', { bubbles: true }));
        }
        rightSuggest.hidden = true; // Vorschlag anwenden + Popup schließen
      });
    });
  }

  // ── Größenvergleich (Modal-Shell .wm-size-compare* aus wm-popup.css, Boxen kalender-spezifisch) ──
  function openCalSizeCompare() {
    var isMobile = window.innerWidth < 768;
    var oldO = document.getElementById('wm-cal-sc-overlay'); if (oldO) oldO.remove();
    var oldP = document.getElementById('wm-cal-sc-popup'); if (oldP) oldP.remove();

    // Größen dynamisch aus den Größe-Buttons lesen (immer synchron mit dem Produkt)
    var group = findOptionGroup(cfg.optionNames.size);
    var sizes = [];
    if (group) group.querySelectorAll('.wm-size-btn').forEach(function (b) {
      var s = sizeInfo(b.dataset.optionValue);
      sizes.push({ w: s.w, h: s.h, label: b.dataset.optionValue });
    });
    if (!sizes.length) return;
    var maxW = Math.max.apply(null, sizes.map(function (s) { return s.w; }));
    var maxH = Math.max.apply(null, sizes.map(function (s) { return s.h; }));
    sizes.sort(function (a, b) { return (b.w * b.h) - (a.w * a.h); }); // größte zuerst (hinten)

    var boxes = sizes.map(function (s, i) {
      var wp = (s.w / maxW * 100).toFixed(2), hp = (s.h / maxH * 100).toFixed(2);
      return '<div class="wm-cal-sc__box" style="width:' + wp + '%;height:' + hp + '%;z-index:' + (i + 2) + '">' +
             '<span class="wm-cal-sc__label">' + s.label + '</span></div>';
    }).join('');

    var overlay = document.createElement('div');
    overlay.id = 'wm-cal-sc-overlay';
    overlay.className = 'wm-size-compare-overlay';
    overlay.textContent = '​';
    document.body.appendChild(overlay);

    var sc = document.createElement('div');
    sc.id = 'wm-cal-sc-popup';
    sc.className = 'wm-size-compare' + (isMobile ? ' wm-size-compare--mobile' : '');
    sc.innerHTML =
      '<button class="wm-size-compare__close" type="button">&times;</button>' +
      '<div class="wm-size-compare__content">' +
        '<h3>Größenvergleich</h3>' +
        '<div class="wm-cal-sc__container" style="aspect-ratio:' + maxW + '/' + maxH + '">' + boxes + '</div>' +
      '</div>';
    document.body.appendChild(sc);

    setTimeout(function () { overlay.classList.add('active'); sc.classList.add('active'); }, 10);
    function close() {
      overlay.classList.remove('active'); sc.classList.remove('active');
      setTimeout(function () { overlay.remove(); sc.remove(); }, 300);
    }
    overlay.addEventListener('click', close);
    sc.querySelector('.wm-size-compare__close').addEventListener('click', close);
    document.addEventListener('keydown', function h(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', h); } });
  }
  var sizeCompareLink = document.getElementById('wm-cal-size-compare');
  if (sizeCompareLink) sizeCompareLink.addEventListener('click', function (e) { e.preventDefault(); openCalSizeCompare(); });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var ddL = popup.querySelector('.wm-cal-fontdd__list');
    if (ddL && !ddL.hidden) { ddL.hidden = true; var ddT = popup.querySelector('.wm-cal-fontdd__toggle'); if (ddT) ddT.setAttribute('aria-expanded', 'false'); popup.style.overflow = ''; return; }
    if (suggest && !suggest.hidden) { suggest.hidden = true; return; } // erst Vorschläge schließen
    if (rightSuggest && !rightSuggest.hidden) { rightSuggest.hidden = true; return; }
    if (expert && !expert.hidden) { expert.hidden = true; return; }
    if (popup.style.display !== 'none') closePopup();
  });

  // ── Button-Klick: zum nächsten offenen Schritt führen ODER (wenn vollständig) ATC ──
  atcBtn && atcBtn.addEventListener('click', function () {
    if (atcBtn.dataset.mode === 'guide') { goToStep(atcBtn.dataset.step); return; }
    addToCart();
  });

  function findOptionGroup(name) {
    var groups = popup.querySelectorAll('.wm-cal-popup-variant-picker .wm-cal-option');
    for (var i = 0; i < groups.length; i++) { if (optionName(groups[i]) === name) return groups[i]; }
    return null;
  }

  // Zur Oberkante (Titel) eines Felds/Options-Blocks scrollen — mobil unter Header + sticky Vorschau.
  function scrollToTitle(el) {
    var offset = 12;
    if (window.matchMedia('(max-width: 989px)').matches) {
      var header = popup.querySelector('.wm-popup__header');
      var preview = popup.querySelector('.wm-popup__preview');
      offset = (header ? header.offsetHeight : 0) + (preview ? preview.offsetHeight : 0) + 12;
    }
    var top = popup.scrollTop + el.getBoundingClientRect().top - popup.getBoundingClientRect().top - offset;
    popup.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function goToStep(step) {
    var el = null, focusEl = null;
    if (step === 'persons') {
      focusEl = popup.querySelector('.wm-cal__persons .wm-cal__person-btn');
      el = focusEl && focusEl.closest('.wm-cal__field');
    } else if (step === 'title') {
      focusEl = titleInput; el = titleInput && titleInput.closest('.wm-cal__field');
    } else if (step === 'names') {
      for (var i = 0; i < state.persons; i++) { if (!filled(nameInputs[i])) { focusEl = nameInputs[i]; break; } }
      el = focusEl && focusEl.closest('.wm-cal__field');
    } else if (step === 'right') {
      focusEl = filled(rightInputs[0]) ? rightInputs[1] : rightInputs[0];
      el = focusEl && focusEl.closest('.wm-cal__field');
    } else if (step === 'marker') {
      el = document.getElementById('wm-cal-gift');
      focusEl = el && el.querySelector('.wm-cal-gift__btn:not([disabled])');
    } else {
      var nameMap = { wandhalter: cfg.optionNames.wandhalter, magnetboard: cfg.optionNames.magnetboard, size: cfg.optionNames.size };
      el = findOptionGroup(nameMap[step]);
      focusEl = el && el.querySelector('.wm-size-btn');
    }
    if (!el) return;
    scrollToTitle(el);
    // Fokus danach, ohne erneut zu scrollen (Titel bleibt oben sichtbar)
    if (focusEl && focusEl.focus) setTimeout(function () { focusEl.focus({ preventScroll: true }); }, 380);
  }

  // ── Warenkorb-Vorschau: den personalisierten Kalender als Bild rendern + hochladen (Cart-Thumbnail) ──
  function loadCrossImg(src) {
    return new Promise(function (resolve, reject) {
      if (!src) { reject(); return; }
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(); };
      img.src = src;
    });
  }
  // W/H = Region des Kalenders im Bild, oy = vertikaler Offset (Letterbox-Rand oben).
  function drawPreviewText(ctx, a, value, W, H, oy) {
    if (!a) return;
    var text = (value || '').trim();
    if (!text) return; // im Warenkorb nur echte Eingaben zeigen (keine Platzhalter)
    var fs = a.relSize * H * (state.fontScale || 1);
    ctx.fillStyle = '#111111';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    ctx.font = '300 ' + fs + 'px ' + state.font;
    try { ctx.letterSpacing = (state.letterSpacing ? state.letterSpacing * W / curW : 0) + 'px'; } catch (e) {}
    var maxW = (a.maxW || 0.9) * W;
    var w = ctx.measureText(text).width;
    if (w > maxW) { fs = fs * maxW / w; ctx.font = '300 ' + fs + 'px ' + state.font; }
    ctx.fillText(text, a.cx * W, oy + a.cy * H);
    try { ctx.letterSpacing = '0px'; } catch (e) {}
  }
  async function generateCalendarPreviewBlob() {
    try {
      try { await document.fonts.load('20px ' + state.font); } catch (e) {}
      // Quadratisches Bild (1:1) mit dem Querformat-Kalender voll auf Breite, mittig → freier Rand oben/unten.
      var S = 1000;
      var W = S, H = Math.max(1, Math.round(S * (curH / curW)));
      var oy = Math.round((S - H) / 2);
      var canvas = document.createElement('canvas'); canvas.width = S; canvas.height = S;
      var ctx = canvas.getContext('2d');
      // Nur die Kalender-Region weiß füllen; Rand oben/unten bleibt transparent → Cart-Hintergrundfarbe.
      ctx.fillStyle = '#ffffff'; ctx.fillRect(0, oy, W, H);
      // Sichtbare Layer in Reihenfolge (base → magnetboard → wandhalter → druck), in die Kalender-Region
      var layers = [];
      if (elBase && elBase.getAttribute('src')) layers.push(elBase.src);
      if (elMag && !elMag.hidden && elMag.getAttribute('src')) layers.push(elMag.src);
      if (elWand && elWand.getAttribute('src')) layers.push(elWand.src);
      if (elDruck && elDruck.getAttribute('src')) layers.push(elDruck.src);
      for (var i = 0; i < layers.length; i++) {
        try { var im = await loadCrossImg(layers[i]); ctx.drawImage(im, 0, oy, W, H); } catch (e) {}
      }
      var L = currentLayout(readOptions());
      if (L) {
        drawPreviewText(ctx, L.title, titleInput && titleInput.value, W, H, oy);
        for (var n = 0; n < state.persons && n < L.names.length; n++) drawPreviewText(ctx, L.names[n], nameInputs[n] && nameInputs[n].value, W, H, oy);
        if (L.right[0]) drawPreviewText(ctx, L.right[0], rightInputs[0] && rightInputs[0].value, W, H, oy);
        if (L.right[1]) drawPreviewText(ctx, L.right[1], rightInputs[1] && rightInputs[1].value, W, H, oy);
      }
      return await new Promise(function (resolve) { canvas.toBlob(function (b) { resolve(b); }, 'image/png'); });
    } catch (e) { return null; }
  }
  async function uploadCalendarPreview() {
    var blob = await generateCalendarPreviewBlob();
    if (!blob) return '';
    var signedRes = await fetch(SIGNED_URL_ENDPOINT, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ contentType: 'image/png', bucket: 'customer-previews' })
    });
    if (!signedRes.ok) return '';
    var signedData = await signedRes.json();
    var up = await fetch(signedData.signedUrl, { method: 'PUT', headers: { 'Content-Type': 'image/png' }, body: blob });
    if (!up.ok) return '';
    return signedData.publicUrl || '';
  }

  async function addToCart() {
    var r = updateAll();
    if (!r.variant) return;
    var opt = r.opt;
    var config = {
      size: sizeInfo(opt.byName[cfg.optionNames.size]).token,
      wandhalter: colorToken(opt.byName[cfg.optionNames.wandhalter]),
      magnetboard: magToken(opt.byName[cfg.optionNames.magnetboard]),
      persons: state.persons,
      title: (titleInput && titleInput.value || '').trim(),
      names: nameInputs.slice(0, state.persons).map(function (i) { return (i.value || '').trim(); }),
      rightFields: rightInputs.map(function (i) { return (i.value || '').trim(); }),
      // Schrift-Infos für den Druck (Backend mappt font-family → TTF; Experten-Feineinstellung)
      font: state.font,
      fontScale: state.fontScale,
      letterSpacing: state.letterSpacing
    };
    atcBtn.disabled = true;
    atcBtn.textContent = 'Wird hinzugefügt…';
    // Personalisierte Vorschau fürs Warenkorb-Thumbnail (max. 6s, blockiert den Kauf bei Fehler NICHT).
    var previewUrl = '';
    try {
      previewUrl = await Promise.race([
        uploadCalendarPreview(),
        new Promise(function (res) { setTimeout(function () { res(''); }, 6000); })
      ]);
    } catch (e) {}
    var props = { '_calendar_config': JSON.stringify(config) };
    if (previewUrl) props['_preview_url'] = previewUrl;
    // Kalender + (falls gewählt) gratis Kreidemarker in einem Rutsch. Auf den Marker greift
    // im Warenkorb ein automatischer Produktrabatt (macht ihn kostenlos).
    var items = [{ id: r.variant.id, quantity: 1, properties: props }];
    if (state.markerVariant) items.push({ id: parseInt(state.markerVariant, 10), quantity: 1, properties: { '_geschenk': 'Gratis Kreidemarker zum Kalender' } });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { if (!res.ok) throw new Error('ATC ' + res.status); return res.json(); })
      .then(function () { openCartDrawerOrRedirect(); })
      .catch(function () { atcBtn.disabled = false; updateButton(r.variant); });
  }

  function openCartDrawerOrRedirect() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) { window.location.href = '/cart'; return; }
    var sectionId = (cartDrawer.closest('.shopify-section') && cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')) || 'cart-drawer';
    fetch('/?sections=' + sectionId)
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections[sectionId];
        if (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var fresh = tmp.querySelector('cart-drawer');
          if (fresh) cartDrawer.innerHTML = fresh.innerHTML;
        }
        cartDrawer.classList.add('active');
        cartDrawer.classList.remove('is-empty');
        document.body.classList.add('overflow-hidden');
        closePopup();
      })
      .catch(function () { window.location.href = '/cart'; });
  }

  // ── Persistenz: Personalisierung in localStorage (überlebt Reload) ──
  var LS_KEY = 'wm_cal_perso_' + (popup.dataset.productId || 'default');
  function saveState() {
    try {
      localStorage.setItem(LS_KEY, JSON.stringify({
        persons: state.persons, personsChosen: state.personsChosen,
        font: state.font, fontScale: state.fontScale, letterSpacing: state.letterSpacing, fontSettings: state.fontSettings,
        title: titleInput ? titleInput.value : '',
        names: nameInputs.map(function (i) { return i.value; }),
        right: rightInputs.map(function (i) { return i.value; }),
        options: readOptions().byName,
        markerId: state.markerVariant,
        visited: visited
      }));
    } catch (e) {}
  }
  function restoreState() {
    var d;
    try { d = JSON.parse(localStorage.getItem(LS_KEY) || 'null'); } catch (e) {}
    if (!d) return;
    if (d.personsChosen && d.persons) {
      state.persons = d.persons; state.personsChosen = true;
      personBtns.forEach(function (b) {
        var a = parseInt(b.getAttribute('data-persons'), 10) === d.persons;
        b.classList.toggle('is-active', a); b.setAttribute('aria-pressed', a ? 'true' : 'false');
      });
    }
    // Gespeicherte Schrift nur übernehmen, wenn sie noch als Option existiert (z.B. altes „Standard" wurde entfernt).
    if (d.font) {
      var fontKnown = false;
      popup.querySelectorAll('.wm-cal-fontdd__item').forEach(function (it) { if (it.getAttribute('data-font') === d.font) fontKnown = true; });
      if (!fontKnown) d.font = null; // unbekannt → Default behalten
    }
    if (d.font) {
      state.font = d.font;
      popup.querySelectorAll('.wm-cal-fontdd__item').forEach(function (it) {
        var a = it.getAttribute('data-font') === d.font;
        it.setAttribute('aria-selected', a ? 'true' : 'false');
        if (a) { var cur = popup.querySelector('.wm-cal-fontdd__current'); if (cur) { cur.textContent = it.textContent; cur.style.fontFamily = d.font; } }
      });
      if (document.fonts && document.fonts.load) { try { document.fonts.load('20px ' + d.font); } catch (e) {} }
    }
    // Pro-Schrift-Einstellungen wiederherstellen (+ Migration alter globaler Werte auf die gespeicherte Schrift)
    if (d.fontSettings && typeof d.fontSettings === 'object') { state.fontSettings = d.fontSettings; }
    if (!state.fontSettings[state.font]) {
      var mScale = typeof d.fontScale === 'number' ? d.fontScale : 1;
      var mSpacing = typeof d.letterSpacing === 'number' ? d.letterSpacing : 0;
      if (mScale !== 1 || mSpacing !== 0) state.fontSettings[state.font] = { scale: mScale, spacing: mSpacing };
    }
    if (loadFontSettings) {
      loadFontSettings(state.font); // aktive Werte + Slider aus der Schrift-Einstellung setzen
    } else {
      if (typeof d.fontScale === 'number') { state.fontScale = d.fontScale; var fsR = document.getElementById('wm-cal-fontscale'), fsV = document.getElementById('wm-cal-fontscale-val'); if (fsR) { fsR.value = Math.round(d.fontScale * 100); if (fsV) fsV.textContent = fsR.value + ' %'; } }
      if (typeof d.letterSpacing === 'number') { state.letterSpacing = d.letterSpacing; var lsR = document.getElementById('wm-cal-letterspacing'), lsV = document.getElementById('wm-cal-letterspacing-val'); if (lsR) { lsR.value = d.letterSpacing; if (lsV) lsV.textContent = d.letterSpacing; } }
    }
    if (titleInput && d.title != null) titleInput.value = d.title;
    if (d.names) nameInputs.forEach(function (i, idx) { if (d.names[idx] != null) i.value = d.names[idx]; });
    if (d.right) rightInputs.forEach(function (i, idx) { if (d.right[idx] != null) i.value = d.right[idx]; });
    if (d.options && picker) {
      Object.keys(d.options).forEach(function (name) {
        var val = d.options[name]; if (!val) return;
        var group = findOptionGroup(name); if (!group) return;
        group.querySelectorAll('.wm-size-btn').forEach(function (b) {
          var a = b.dataset.optionValue === val; b.classList.toggle('wm-size-btn--active', a);
          if (a) { var h = picker.querySelector('[data-option-header="' + b.dataset.optionPosition + '"]'); if (h) h.textContent = val; }
        });
      });
    }
    if (d.markerId) {
      var mb = giftBtns.filter(function (b) { return b.dataset.markerId === String(d.markerId); })[0];
      if (mb && !mb.disabled) {
        giftBtns.forEach(function (b) { b.classList.remove('wm-size-btn--active'); });
        mb.classList.add('wm-size-btn--active');
        state.markerVariant = mb.dataset.markerId;
        setGiftValue(mb.dataset.markerLabel);
        setGiftStrike(parseInt(mb.dataset.markerPrice, 10) || 0);
        setGiftPack(mb.dataset.markerImg);
      }
    }
    if (d.visited && typeof d.visited === 'object') visited = d.visited;
  }

  // Alle möglichen Overlays vorladen, damit Wechsel (Personenzahl/Wandhalter/Magnetboard)
  // sofort ohne Nachladen/Flackern erscheinen.
  function preloadOverlays() {
    var urls = [cfg.base];
    Object.keys(cfg.bg || {}).forEach(function (k) { urls.push(cfg.bg[k]); });
    Object.keys(cfg.wandhalter || {}).forEach(function (k) { urls.push(cfg.wandhalter[k].fuer, cfg.wandhalter[k].ohne); });
    Object.keys(cfg.magnetboard || {}).forEach(function (k) { urls.push(cfg.magnetboard[k]); });
    urls.forEach(function (u) { if (u) { var img = new Image(); img.src = u; } });
  }
  preloadOverlays();
  restoreState();

  // PDP-Vorauswahl: hat restoreState keine Größe gesetzt, die Bestseller-Größe im Popup vorwählen
  // (nur wenn ein PDP-Größen-Picker existiert) → PDP-Preis konkret + Popup öffnet auf dieser Größe.
  // Das folgende updateAll() spiegelt die Größe dann auf die PDP (Aktiv-Button + Preis).
  (function () {
    if (!pdpSizeBtns.length) return;
    var g = findOptionGroup(cfg.optionNames.size);
    if (!g || g.querySelector('.wm-size-btn--active')) return; // restoreState hat schon eine Größe gesetzt
    var def = pdpDefaultSize();
    if (def) activatePopupSize(def);
  })();

  updateNameVisibility();
  updateAll();
  // Aktuelle Schrift (Default oder wiederhergestellt) laden und dann neu rendern, damit Shrink-to-Fit
  // die echte Webschrift misst statt der Fallback-Schrift.
  if (document.fonts && document.fonts.load) {
    try { document.fonts.load('20px ' + state.font).then(function () { updateAll(); }, function () {}); } catch (e) {}
  }
})();
